<template>
  <div class="calendar">
    <v-date-picker
      v-model="date"
      :events="value"
      first-day-of-week="1"
      :locale="selectedLocale"
      event-color="planned-event"
      color="primary"
      no-title
      flat
      full-width
      show-current
      @input="inputHandler"
      @click="inputHandler(date, $event)"
    >
      <div class="legend">
        <div class="legend__color legend__color--selected"></div>
        <div class="legend__text">{{ $t("message.posts.list.planned") }}</div>
      </div>
    </v-date-picker>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "PostCalendar",
  props: {
    value: {
      required: true,
      type: Array
    }
  },
  computed: {
    ...mapState({
      selectedLocale: state => state.settings.selectedLocale
    })
  },
  data() {
    return {
      date: null,
      lastDate: null,
      events: []
    };
  },

  methods: {
    inputHandler() {
      if (this.lastDate === this.date) this.date = null;
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.POSTS_LIST_SCHEDULE_CALENDAR_ACTION,
        date: this.date
      });

      this.$emit("input", this.date);
      this.lastDate = this.date;
    }
  }
};
</script>

<style lang="scss" scoped>
.calendar {
  border-radius: 20px;
  border: 1px solid $gray-300;
  transition: transform 0.1s;
  overflow: hidden;

  ::v-deep .v-btn__content {
    @include font-size(15px);
  }

  ::v-deep .v-btn {
    &.v-date-picker-table__current {
      color: $text !important;

      .v-btn__content {
        color: $text;
      }
    }
  }
  ::v-deep .v-btn {
    &.v-date-picker-table__current.v-btn--active {
      .v-btn__content {
        color: white;
      }
    }
  }

  ::v-deep .v-date-picker-table__events {
    margin: 0;
    height: 100%;
    width: 100%;

    .planned-event {
      top: 6px;
      margin: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      left: 0;
      right: 0;
      position: absolute;
      z-index: -1;
      background: #ebe8f6;
    }
  }
}

.legend {
  display: flex;
  align-items: center;
  padding: 0 $spacing * 2;

  &__color {
    width: 16px;
    height: 16px;
    margin-right: $spacing;
    border-radius: 100%;

    &--selected {
      background: #ebe8f6;
    }
  }

  &__text {
    @include font-size(14px);
  }
}
</style>
